{
  "title": "Search",
  "programmesTitle": "Programmes and courses",
  "placeholder": "Search",
  "sort": {
    "label": "Sort by",
    "relevance": "Relevance",
    "alphabetical": "Alphabetical"
  },
  "showAll": "Show all ({{count}})",
  "tabs": {
    "all": "All results",
    "programmes": "Programmes and courses",
    "articles": "Articles",
    "employees": "Employees",
    "events": "Events"
  },
  "count": {
    "All": "Showing {{count}} results",
    "Programmes": "Showing {{count}} programmes and courses",
    "Articles": "Showing {{count}} articles",
    "Employees": "Showing {{count}} employees",
    "Events": "Showing {{count}} events"
  },
  "findExpert": {
    "title": "Expert Competence",
    "description": "Are you looking for someone with insight on a certain topic?",
    "linkText": "Find an expert"
  },
  "pagination": {
    "nextPage": "Next page",
    "previousPage": "Previous page",
    "page": "Page {{page}}"
  },
  "filter": {
    "header": "Filter",
    "toggleButton": "Filter",
    "resetButton": "Reset filter",
    "applyButton": "Apply filter",
    "closeButton": "Close filter"
  },
  "article": {
    "noResults": "There is unfortunately no articles matching the search criteria",
    "typeFilter_zero": "Article",
    "typeFilter": "Article ({{count}})",
    "type": "Article",
    "types": {
      "BiBusinessReview": "BI Business Review",
      "News": "News",
      "Other": "Other"
    },
    "yearFilter_zero": "Year",
    "yearFilter": "Year ({{count}})",
    "year": "Year"
  },
  "employee": {
    "noResults": "There is unfortunately no employees matching the search criteria",
    "phone": "Phone",
    "mail": "Email",
    "location": "Office",
    "campusFilter_zero": "Campus",
    "campusFilter": "Campus ({{count}})",
    "campus": "Campus",
    "campuses": {
      "Oslo": "Oslo",
      "Bergen": "Bergen",
      "Stavanger": "Stavanger",
      "Trondheim": "Trondheim"
    }
  },
  "event": {
    "noResults": "There is unfortunately no events matching the search criteria",
    "when": "When",
    "where": "Where",
    "campusFilter_zero": "Campus",
    "campusFilter": "Campus ({{count}})",
    "campus": "Campus",
    "campuses": {
      "Oslo": "Oslo",
      "Bergen": "Bergen",
      "Stavanger": "Stavanger",
      "Trondheim": "Trondheim"
    },
    "typeFilter_zero": "Event",
    "typeFilter": "Event ({{count}})",
    "type": "Event",
    "types": {
      "alumni-partner": "Business and Alumni activities",
      "alumni-conference": "Alumni conferences",
      "research": "Research",
      "Executive": "Executive education",
      "executive-webinar": "Executive webinar",
      "bi-startup": "BI Startup",
      "leaders-toolbox": "Leaders toolbox",
      "sustainability": "Sustainability",
      "bachelor": "Bachelor",
      "master": "Master",
      "phd": "PhD"
    }
  },
  "programme": {
    "noResults": "There is unfortunately no programmes or courses matching the search criteria",
    "credits": "{{count}} ECTS",
    "loadFilter_zero": "Study form",
    "loadFilter": "Study form ({{count}})",
    "load": "Study form",
    "loads": {
      "FullTime": "Full-time",
      "PartTime": "Part-time"
    },
    "languageFilter_zero": "Teaching language",
    "languageFilter": "Teaching language ({{count}})",
    "language": "Teaching language",
    "languages": {
      "Norwegian": "Norwegian",
      "English": "English"
    },
    "campusFilter_zero": "Campus",
    "campusFilter": "Campus ({{count}})",
    "campus": "Campus",
    "campuses": {
      "Oslo": "Oslo",
      "Bergen": "Bergen",
      "Stavanger": "Stavanger",
      "Trondheim": "Trondheim",
      "Online": "Online"
    },
    "levelFilter_zero": "Level",
    "levelFilter": "Level ({{count}})",
    "level": "Level",
    "levels": {
      "Bachelor": "Bachelor",
      "Master": "Master",
      "PhD": "PhD",
      "NonCreditCourses": "Non-credit courses",
      "OneYearProgrammes": "One-year programmes",
      "AllCourses": "All courses",
      "BachelorCourses": "Bachelor courses",
      "MasterCourses": "Master courses"
    },
    "semesterFilter_zero": "Start date",
    "semesterFilter": "Start date ({{count}})",
    "semester": "Start date",
    "semesters": {
      "Fall_zero": "Autumn",
      "Fall": "Autumn {{year}}",
      "Spring_zero": "Spring",
      "Spring": "Spring {{year}}"
    },
    "academicFieldFilter_zero": "Academic field",
    "academicFieldFilter": "Academic field ({{count}})",
    "academicField": "Academic field",
    "academicFields": {
      "RealEstateRetailAndBusinessLaw": "Real Estate, Retail and Business Law",
      "FinanceEconomicsAndGovernance": "Finance, Economics and Governance",
      "Management": "Management",
      "MarketingCommunicationAndCulture": "Marketing, Communication and Culture",
      "PublicSector": "Public Sector",
      "ProjectManagement": "Project Management",
      "StrategyInnovationAndSustainability": "Strategy, Innovation and Sustainability",
      "OrganisationalDevelopmentAndHumanResourceManagement": "Organisational Development and Human Resource Management",
      "DigitalisationAndAnalytics": "Digitalisation and Analytics",
      "InternationalBusiness": "International Business"
    }
  }
}
